import React, { FC } from 'react'
import ClientDelegateAddModal, { openDelegateAddModal } from './ClientDelegateAddModal'
import ClientDelegateViewModal, { openDelegateViewModal } from './ClientDelegateViewModal'
import ClientDelegateDeleteModal, { openDelegateDeleteModal } from './ClientDelegateDeleteModal'
import { linkedFile } from 'src/features/ClientDetails/types'

const Modals: FC<{
  ID: string
  hash: string
  linkedfiles: linkedFile[]
}> = ({ ID, hash, linkedfiles }) => (
  <>
    <ClientDelegateAddModal
      //@ts-ignore
      ID={ID}
      hash={hash}
      linkedfiles={linkedfiles}
    />
    {/* @ts-ignore */}
    <ClientDelegateViewModal ID={ID} hash={hash} linkedfiles={linkedfiles} />
    <ClientDelegateDeleteModal />
  </>
)

export { openDelegateAddModal, openDelegateDeleteModal, openDelegateViewModal }

export default Modals
